import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";
import { reviews } from "../data/reviews";

export const Reviews = () => {
  const { t } = useLanguage();
  // Build two-row marquee
  const half = Math.ceil(reviews.length / 2);
  const row1 = reviews.slice(0, half);
  const row2 = reviews.slice(half);

  const renderCard = (r, i) => (
    <div
      key={`${r.name}-${i}`}
      className="shrink-0 w-[320px] md:w-[380px] rounded-2xl border border-[#D8DCE2]/8 bg-[#1A1C22] p-6 mr-5"
      data-testid={`review-card-${i}`}
    >
      <div className="flex items-center gap-3 mb-4">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center font-display text-[13px] font-bold border"
          style={{ background: "#0a0b0f", borderColor: "#D7B56D55", color: "#D7B56D" }}
        >
          {r.name[0]}
        </div>
        <div>
          <div className="font-display text-[13px] font-bold text-[#F5F1EA] leading-none">{r.name}</div>
          <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-[#A9824A] mt-1.5">
            {r.country} · {r.level}
          </div>
        </div>
      </div>
      <p className="text-[12.5px] text-[#E6E0D6]/85 leading-relaxed line-clamp-5 mb-4">{r.text}</p>
      <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-[#76D9E8]">{r.access}</div>
    </div>
  );

  return (
    <section id="reviews" className="relative py-24 md:py-32 overflow-hidden" data-testid="reviews-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 lg:px-16">
        <div className="mb-14 md:mb-16 max-w-3xl">
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#A9824A] mb-3">
            · 12 / Stories ({reviews.length}+)
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-[#F5F1EA] leading-[0.98]">
            {t("rvTitle")}
          </h2>
          <p className="mt-5 text-[15px] text-[#E6E0D6]/80 leading-relaxed">{t("rvSub")}</p>
          <p className="mt-2 text-[12px] text-[#D8DCE2]/45">{t("rvDisclaimer")}</p>
        </div>
      </div>

      {/* Marquee row 1 */}
      <div className="relative mb-5">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0b0f] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0b0f] to-transparent z-10 pointer-events-none" />
        <div className="flex marquee-track" style={{ width: "max-content" }}>
          {[...row1, ...row1].map((r, i) => renderCard(r, i))}
        </div>
      </div>

      {/* Marquee row 2 reversed */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0b0f] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0b0f] to-transparent z-10 pointer-events-none" />
        <div
          className="flex marquee-track"
          style={{ width: "max-content", animationDirection: "reverse", animationDuration: "110s" }}
        >
          {[...row2, ...row2].map((r, i) => renderCard(r, i))}
        </div>
      </div>
    </section>
  );
};
